function range(len) {
    return Array(len).fill(0).map((value, index) => index);
}

function linear(y, x = null) {
    if (!y) {
        return [];
    }

    if (!x) {
        x = range(y.length);
    }

    let p0 = null;
    let p1 = null;
    let result = {};
    let interpolatedX = [];

    for (let index in y) {
        let yn = y[index];
        let xn = x[index];

        if (yn !== null) {
            if (p0 === null) {
                p0 = {x: xn, y: yn};
                if (interpolatedX.length > 0) {
                    for (let xi of interpolatedX) {
                        result[xi] = null;
                    }

                    interpolatedX = [];
                }
            }
            else if (p1 === null) {
                p1 = {x: xn, y: yn};

                let k = (p1.y - p0.y)/(p1.x - p0.x);
                let b = p0.y - k*p0.x;
                for (let xi of interpolatedX) {
                    let yi = k*xi + b;
                    result[xi] = yi;
                }

                interpolatedX = [];
                p0 = p1;
                p1 = null;
            }

            result[xn] = yn;
        }
        else {
            interpolatedX.push(xn);
        }
    }

    if (interpolatedX.length > 0) {
        for (let xi of interpolatedX) {
            result[xi] = null;
        }
    }

    let interpolatedY = x.map(xn => result[xn]);
    return interpolatedY;
}

function getRow(array2d, rowIndex) {
    return array2d[rowIndex] || [];
}

function setRow(array2d, rowIndex, row) {
    array2d[rowIndex] = row;
    return array2d;
}

function getCol(array2d, colIndex) {
    let col = [];
    for (let row of array2d) {
        col.push(row[colIndex]);
    }

    return col;
}

function setCol(array2d, colIndex, col) {
    for (let rowIndex in array2d) {
        array2d[rowIndex][colIndex] = col[rowIndex];
    }

    return array2d;
}

export function bilinear(z, x = null, y = null) {
    if (!z) {
        return [];
    }

    let shapeY = z.length;
    let shapeX = shapeY > 0 ? z[0].length : 0;
    if (shapeY === 0 || shapeX === 0) {
        return [];
    }

    if (!x) {
        x = range(shapeX);
    }

    if (!y) {
        y = range(shapeY);
    }

    for (let rowIndex in z) {
       let zx = getRow(z, rowIndex);
       let interpolatedZx = linear(zx, x);
       z = setRow(z, rowIndex, interpolatedZx);
    }

    for (let colIndex in z[0]) {
        let zy = getCol(z, colIndex);
        let interpolatedZy = linear(zy, y);
        z = setCol(z, colIndex, interpolatedZy);
    }

    return z;
}

export default {linear, bilinear, getRow, setRow, getCol, setCol}